import DragDropIndicator from '@/components/DragDrops/DragDropIndicator';
import Header from './SectionHeader';
import Details from './SectionDetails';

import { getListKeywords, getUniqueKeywords, isEmpty } from '@/common/utils';
import { useGetTags, useMutationSection } from '@/hooks';

export default {
  components: {
    Header,
    Details,
    DragDropIndicator
  },
  props: {
    startSequence: {
      type: Number,
      require: true
    },
    section: {
      type: Object,
      require: true
    },
    isEnable: {
      type: Boolean,
      default: false
    },
    dragTargetType: {
      type: String
    },
    dragSheetTarget: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      keywords: [],
      sectionTags: [],
      isCollapseDetail: true
    };
  },
  setup() {
    const { getSectionTags } = useGetTags();
    const { updateSectionTag, deleteSectionTag } = useMutationSection();
    return { getSectionTags, updateSectionTag, deleteSectionTag };
  },
  computed: {
    dragTargetCssClass() {
      return isEmpty(this.dragTargetType)
        ? ''
        : `drag-target-${this.dragTargetType}`;
    },
    sectionInfo() {
      const {
        id,
        name,
        color,
        dueDate,
        draggable,
        status,
        assigneeId
      } = this.section;

      return { id, name, color, dueDate, draggable, status, assigneeId };
    },
    listKeywords() {
      return getListKeywords([this.section.name]);
    },
    sectionName() {
      return this.section.name;
    }
  },
  methods: {
    /**
     * Fire when dragging sheet target change
     *
     * @param {String | Number} id        target sheet id
     * @param {String}          position  target location (before or after)
     */
    onDragSheetTargetChange({ id, position }) {
      this.$emit('dragSheetTargetChange', { id, position });
    },

    async onToggleTags(isCollapse) {
      this.isCollapseDetail = isCollapse;
      await this.getListTags();
    },

    async getListTags() {
      if (this.isCollapseDetail) {
        this.keywords = [];
        return;
      }
      this.sectionTags = await this.getSectionTags(this.section.id);
      const tags = this.sectionTags.map(item => item.text);
      const listTags = getUniqueKeywords([...this.listKeywords, ...tags]);
      this.keywords = listTags.map(tag => {
        const isSectionTag = this.sectionTags.find(
          item => item.text === tag.value
        );
        if (!isSectionTag) {
          tag.noneOpacity = true;
          tag.active = false;
        }
        return tag;
      });
    },

    async onAddTag(value) {
      const tag = this.sectionTags.find(item => item.text === value);
      if (tag) {
        return;
      }
      await this.updateSectionTag(this.section.id, {
        tags: value
      });
      await this.getListTags();
    },

    async onDeleteTag(val) {
      const tagId = this.sectionTags.find(item => item.text === val.value)?.id;
      if (tagId) {
        await this.deleteSectionTag(this.section.id, [tagId]);
        await this.getListTags();
      }
    }
  },
  watch: {
    async sectionName() {
      await this.getListTags();
    }
  }
};
